var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissionTargetillustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 266.153,
    height: 307.955,
    viewBox: "0 0 266.153 307.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#210321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.013,
    y1: -0.351,
    x2: 0.798,
    y2: 1.181,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.084,
    y1: 0.01,
    x2: 1.147,
    y2: 1.256,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 2.608,
    gradientTransform: "translate(0.261 0.618) scale(0.139 0.139)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#481047",
    stopOpacity: 0.831
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#481047",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.501,
    r: 2.6,
    gradientTransform: "translate(0.431) scale(0.137 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#481047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    stopColor: "#2a0929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#481047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#210321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#210321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#481047"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#481047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -0.023,
    y1: 0.114,
    x2: 0.852,
    y2: 1.221,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#fff",
    stopOpacity: 0.682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -6.604,
    y1: 16.621,
    x2: -7.076,
    y2: 17.044,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffff7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1b747"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -0.494,
    y1: -0.422,
    x2: 0.968,
    y2: 1.261,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    stopColor: "#ffff54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#f5e24e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.032,
    stopColor: "#ecc749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.044,
    stopColor: "#e6b345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.058,
    stopColor: "#e1a442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#de9c41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#dd9940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.143,
    stopColor: "#d0863b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#b65d31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#b75f31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#c87e39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#d7993f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#e3af44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#edc048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#f3cb4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#f7d24d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#f8d44d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#eec149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#da9d40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#ca8139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    stopColor: "#bf6d35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#b86132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#b65d31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#c77b38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796,
    stopColor: "#dca241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.877,
    stopColor: "#ebbd48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947,
    stopColor: "#f5ce4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8d44d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -12.397,
    y1: 35.039,
    x2: -12.898,
    y2: 35.486,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#7a0b21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee8d91",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#481047"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.009,
    y1: 0.499,
    x2: 1.004,
    y2: 0.499,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1,
    y1: -0.335,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#91298c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1b747"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1,
    y1: 1.331,
    x2: -0.29,
    y2: -0.262,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.404,
    y1: 0.253,
    x2: 0.61,
    y2: 1.057,
    xlinkHref: "#linear-gradient-9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4294",
    "data-name": "Group 4294",
    transform: "translate(-58.347 -1675.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background_lines",
    "data-name": "background lines",
    transform: "translate(-1065.653 801.58)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "horizontal_lines",
    "data-name": "horizontal lines",
    transform: "translate(1124.5 916.016)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 264.699,
    transform: "translate(0 90.798)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 264.699,
    transform: "translate(0 136.198)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 264.699,
    transform: "translate(0 181.597)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 264.699,
    transform: "translate(0 45.399)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 264.699,
    transform: "translate(0.454 0)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vertical_lines",
    "data-name": "vertical lines",
    transform: "translate(1345.595 874) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-2",
    "data-name": "Line 1",
    x2: 264.699,
    transform: "translate(0 90.798)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2",
    "data-name": "Line 2",
    x2: 264.699,
    transform: "translate(0 136.198)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-2",
    "data-name": "Line 3",
    x2: 264.699,
    transform: "translate(0 181.597)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-2",
    "data-name": "Line 4",
    x2: 264.699,
    transform: "translate(0 45.399)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5-2",
    "data-name": "Line 5",
    x2: 264.699,
    transform: "translate(0.454 0)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4150",
    "data-name": "Group 4150",
    transform: "translate(230 131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cashless_illustration",
    "data-name": "cashless illustration",
    transform: "matrix(0.799, 0.602, -0.602, 0.799, -43.202, 1584.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coin_2",
    "data-name": "coin 2",
    transform: "matrix(0.799, -0.602, 0.602, 0.799, 159.909, 21.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9911",
    "data-name": "Path 9911",
    d: "M0,5.076s2.558.681,4.23-.846S5.318,0,5.318,0",
    transform: "translate(4.189 3.827)",
    fill: "none",
    stroke: "#e4eff7",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9912",
    "data-name": "Path 9912",
    d: "M5.206.088s-2.59-.543-4.179,1.07S.166,5.441.166,5.441",
    transform: "translate(1.747 1.752)",
    fill: "none",
    stroke: "#e4eff7",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    cx: 5.61,
    cy: 5.41,
    rx: 5.61,
    ry: 5.41,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e4eff7",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10220",
    "data-name": "Path 10220",
    d: "M6.548,3.274A3.274,3.274,0,1,1,3.274,0,3.273,3.273,0,0,1,6.548,3.274Z",
    transform: "matrix(0.799, -0.602, 0.602, 0.799, 15.011, 140.532)",
    fill: "#fbb516"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2742",
    "data-name": "Group 2742",
    transform: "matrix(0.799, -0.602, 0.602, 0.799, 112.05, 38.732)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_306",
    "data-name": "Rectangle 306",
    width: 1.325,
    height: 3.866,
    transform: "matrix(0.248, 0.969, -0.969, 0.248, 9.483, 0)",
    fill: "#91288c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_307",
    "data-name": "Rectangle 307",
    width: 1.325,
    height: 3.866,
    transform: "translate(7.573 1.863) rotate(75.623)",
    fill: "#91288c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    "data-name": "Rectangle 308",
    width: 1.325,
    height: 3.866,
    transform: "translate(5.672 3.73) rotate(75.623)",
    fill: "#91288c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    "data-name": "Rectangle 309",
    width: 1.325,
    height: 3.866,
    transform: "matrix(0.248, 0.969, -0.969, 0.248, 3.745, 5.58)",
    fill: "#91288c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10221",
    "data-name": "Path 10221",
    d: "M3.336,10.133,0,3.336,6.8,0l3.336,6.8ZM2.027,4.022,4.038,8.107,8.122,6.1,6.111,2.011Z",
    transform: "matrix(0.799, -0.602, 0.602, 0.799, 207.169, 166.277)",
    fill: "#91288c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "wallet",
    transform: "translate(1.728 101.685) rotate(-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9913",
    "data-name": "Path 9913",
    d: "M13.506,6.512h-.482V2.653a.241.241,0,0,0-.241-.241H11.322l-.48-1.52A.241.241,0,0,0,10.526.74l-1.964.749L7.68.112A.241.241,0,0,0,7.527.006.236.236,0,0,0,7.345.04L3.723,2.412H1.688A1.69,1.69,0,0,0,0,4.1v8.683a1.69,1.69,0,0,0,1.688,1.688H12.783a.241.241,0,0,0,.241-.241V11.336h.482a.965.965,0,0,0,.965-.965V7.477A.965.965,0,0,0,13.506,6.512Zm0,.482a.482.482,0,1,1,0,.965h-.482V6.995Zm-.965-4.1V5.306h-.305l-.762-2.412ZM11.73,5.306h-.7L10.359,3.3a.241.241,0,0,0-.229-.165.917.917,0,0,1-.653-.27l-.141-.141a.241.241,0,0,0-.254-.056L1.945,5.306H1.688a1.2,1.2,0,0,1-.856-.358l9.627-3.666Zm-1.211,0H3.336L9.1,3.174l.032.032a1.394,1.394,0,0,0,.816.4ZM7.4.577l.7,1.087L2.475,3.807ZM1.688,2.895h1.3L.553,4.49A1.19,1.19,0,0,1,.482,4.1,1.207,1.207,0,0,1,1.688,2.895ZM12.542,13.989H1.688A1.207,1.207,0,0,1,.482,12.783v-7.5l.007.007c.019.019.039.036.058.054s.04.038.062.056.042.032.063.048.044.034.067.05.046.028.068.042.047.03.072.043l.074.036.074.036c.026.012.055.02.082.03s.048.019.074.027.062.017.093.024.046.013.07.018.072.012.108.017l.06.009a1.725,1.725,0,0,0,.172.008H2l0,.009.026-.009h10.51V7.959H9.889a1.688,1.688,0,0,0,0,3.377h2.653Zm1.447-3.618a.482.482,0,0,1-.482.482H9.889a1.206,1.206,0,0,1,0-2.412h3.618a.958.958,0,0,0,.173-.018l.041-.008a.962.962,0,0,0,.16-.05l.008,0a.956.956,0,0,0,.1-.05Zm0,0",
    transform: "translate(0 0)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9914",
    "data-name": "Path 9914",
    d: "M0,0H.965V.482H0ZM0,0",
    transform: "translate(5.203 6.512)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9915",
    "data-name": "Path 9915",
    d: "M0,0H.965V.482H0ZM0,0",
    transform: "translate(3.273 6.512)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9916",
    "data-name": "Path 9916",
    d: "M0,0H.827V.482H0ZM0,0",
    transform: "translate(10.991 6.512)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9917",
    "data-name": "Path 9917",
    d: "M0,0H.965V.482H0ZM0,0",
    transform: "translate(9.062 6.512)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9918",
    "data-name": "Path 9918",
    d: "M.113,0,0,.468A1.717,1.717,0,0,0,.4.516h.62V.034H.4A1.241,1.241,0,0,1,.113,0Zm0,0",
    transform: "translate(1.291 6.479)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9919",
    "data-name": "Path 9919",
    d: "M0,0H.965V.482H0ZM0,0",
    transform: "translate(7.132 6.512)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9920",
    "data-name": "Path 9920",
    d: "M.113,0,0,.468A1.715,1.715,0,0,0,.4.516h.62V.034H.4A1.237,1.237,0,0,1,.113,0Zm0,0",
    transform: "translate(1.291 12.749)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9921",
    "data-name": "Path 9921",
    d: "M0,0H.827V.482H0ZM0,0",
    transform: "translate(10.991 12.783)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9922",
    "data-name": "Path 9922",
    d: "M0,0H.965V.482H0ZM0,0",
    transform: "translate(5.203 12.783)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9923",
    "data-name": "Path 9923",
    d: "M0,0H.965V.482H0ZM0,0",
    transform: "translate(9.062 12.783)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9924",
    "data-name": "Path 9924",
    d: "M0,0H.965V.482H0ZM0,0",
    transform: "translate(3.273 12.783)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9925",
    "data-name": "Path 9925",
    d: "M0,0H.965V.482H0ZM0,0",
    transform: "translate(7.132 12.783)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9926",
    "data-name": "Path 9926",
    d: "M.724,0a.724.724,0,1,0,.724.724A.724.724,0,0,0,.724,0Zm0,.965A.241.241,0,1,1,.965.724.241.241,0,0,1,.724.965Zm0,0",
    transform: "translate(9.165 8.924)",
    fill: "#e4eff7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2743",
    "data-name": "Group 2743",
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 112.162, 10.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9767",
    "data-name": "Path 9767",
    d: "M2.505.421.321,2.284,0,0Z",
    transform: "translate(4.754 10.471)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9768",
    "data-name": "Path 9768",
    d: "M.157,0,0,10.307a.731.731,0,0,0,.742.742l10.35-.228a.289.289,0,0,0,.193-.5Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9769",
    "data-name": "Path 9769",
    d: "M7.1,10.892,0,0,5.432,10.935l-.585.542Z",
    transform: "translate(0.157)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9770",
    "data-name": "Path 9770",
    d: "M0,.021l.478,1.8L.992,0Z",
    transform: "translate(4.597 10.935)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "matrix(0.978, -0.208, 0.208, 0.978, 217.59, 97.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9927",
    "data-name": "Path 9927",
    d: "M8.821,4.853v.989a.233.233,0,0,0,.044.142,2.728,2.728,0,0,1,.671,2.164,4.719,4.719,0,0,1-1.517,3.113,4.642,4.642,0,0,1-2.829,1.253A4.773,4.773,0,0,1,.24,9.234,3.925,3.925,0,0,1,.073,7.164,2.608,2.608,0,0,1,.67,6a.271.271,0,0,0,.059-.162c0-.6,0-1.189,0-1.787a4.036,4.036,0,0,1,8-.754c.083.509.073,1.028.108,1.547A.037.037,0,0,1,8.821,4.853ZM4.782,5.881H2.628A1.866,1.866,0,0,0,.817,7.257a2.744,2.744,0,0,0,.01,1.322,4.038,4.038,0,0,0,7.994-.837,1.883,1.883,0,0,0-1.87-1.855C6.226,5.881,5.5,5.881,4.782,5.881Zm-1.86-.744H6.593a12.417,12.417,0,0,0-.01-1.351A1.822,1.822,0,0,0,3,3.629,13.872,13.872,0,0,0,2.922,5.137Zm5.164.24c0-.426,0-.847,0-1.273a3.624,3.624,0,0,0-.064-.69A3.3,3.3,0,0,0,1.5,3.693c-.044.553-.02,1.116-.024,1.674,0,0,.01.01,0,.01.24-.073.475-.147.724-.22V4.912c0-.392-.015-.783.024-1.175A2.559,2.559,0,0,1,6.06,1.823,2.5,2.5,0,0,1,7.347,4.055c.01.372,0,.739,0,1.1C7.6,5.23,7.837,5.3,8.086,5.377Z",
    transform: "translate(0 0)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9928",
    "data-name": "Path 9928",
    d: "M.737,3.129c0-.289,0-.578,0-.866a.16.16,0,0,0-.108-.171A1.094,1.094,0,0,1,0,1.019,1.111,1.111,0,0,1,.742.06,1.1,1.1,0,0,1,1.569,2.1a.154.154,0,0,0-.1.171q.007.874,0,1.748a.367.367,0,1,1-.734.01c0-.3,0-.6,0-.9ZM1.471,1.1A.373.373,0,0,0,1.109.731a.373.373,0,0,0-.372.362.376.376,0,0,0,.362.372A.376.376,0,0,0,1.471,1.1Z",
    transform: "translate(3.678 6.668)",
    fill: "#e4eff7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "security",
    transform: "matrix(0.799, -0.602, 0.602, 0.799, 0, 164.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10222",
    "data-name": "Path 10222",
    d: "M13.257,4.068c-.008-.427-.016-.829-.016-1.219a.553.553,0,0,0-.553-.553A7.624,7.624,0,0,1,7.022.157a.553.553,0,0,0-.771,0A7.623,7.623,0,0,1,.586,2.3a.553.553,0,0,0-.553.553c0,.39-.008.793-.016,1.22-.076,3.969-.18,9.405,6.439,11.7a.552.552,0,0,0,.362,0C13.436,13.473,13.333,8.037,13.257,4.068Zm-6.62,10.59C.961,12.6,1.047,8.079,1.123,4.089c0-.239.009-.472.012-.7A8.527,8.527,0,0,0,6.637,1.3a8.528,8.528,0,0,0,5.5,2.085c0,.227.008.459.012.7C12.227,8.079,12.313,12.6,6.637,14.658Z",
    transform: "translate(0 0)",
    fill: "#fbb516"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10223",
    "data-name": "Path 10223",
    d: "M4.752.162,2.083,2.831.944,1.692a.553.553,0,0,0-.782.782L1.692,4a.553.553,0,0,0,.782,0L5.533.944A.553.553,0,0,0,4.752.162Z",
    transform: "translate(3.789 5.816)",
    fill: "#fbb516"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Glass_Triangle1",
    "data-name": "Glass Triangle1",
    transform: "matrix(0.961, -0.276, 0.276, 0.961, 47.529, 38.141)",
    fill: "rgba(255,255,255,0.3)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.61,11.221,11.221,0H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.6104416847229 8.984811782836914 L 9.602847099304199 1.000001668930054 L 1.61803662776947 1.000001668930054 L 5.6104416847229 8.984811782836914 M 5.6104416847229 11.22088146209717 L 1.684722860773036e-06 1.684722860773036e-06 L 11.22088146209717 1.684722860773036e-06 L 5.6104416847229 11.22088146209717 Z",
    stroke: "none",
    fill: "rgba(255,255,255,0.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2777",
    "data-name": "Group 2777",
    transform: "matrix(0.799, -0.602, 0.602, 0.799, 48.105, 240.921)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_176",
    "data-name": "Ellipse 176",
    cx: 77.182,
    cy: 10.745,
    rx: 77.182,
    ry: 10.745,
    transform: "translate(30.324 6.089)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2776",
    "data-name": "Group 2776",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2770",
    "data-name": "Group 2770"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_177",
    "data-name": "Ellipse 177",
    cx: 106.969,
    cy: 16.415,
    rx: 106.969,
    ry: 16.415,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2.259
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_178",
    "data-name": "Ellipse 178",
    cx: 88.464,
    cy: 13.61,
    rx: 88.464,
    ry: 13.61,
    transform: "translate(18.505 2.806)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.781,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_179",
    "data-name": "Ellipse 179",
    cx: 70.019,
    cy: 10.745,
    rx: 70.019,
    ry: 10.745,
    transform: "translate(36.95 5.671)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.304,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_180",
    "data-name": "Ellipse 180",
    cx: 51.514,
    cy: 7.879,
    rx: 51.514,
    ry: 7.879,
    transform: "translate(55.454 8.536)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.826,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_181",
    "data-name": "Ellipse 181",
    cx: 33.07,
    cy: 5.074,
    rx: 33.07,
    ry: 5.074,
    transform: "translate(73.899 11.342)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.349,
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2775",
    "data-name": "Group 2775",
    transform: "translate(63.095 11.521)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 42.202,
    cy: 5.79,
    rx: 42.202,
    ry: 5.79,
    fill: "url(#radial-gradient-2)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "isomatric_coin",
    "data-name": "isomatric coin",
    d: "M8.534,4.233a2.555,2.555,0,0,1,.253,1.039,1.339,1.339,0,0,1-.958,1.343,2.555,2.555,0,0,1-1.065.1M4.809,1.984a1.736,1.736,0,0,0-.871.347,1.273,1.273,0,0,0-.445.715,1.95,1.95,0,0,0,.049.975,3.7,3.7,0,0,0,.536,1.086m6.675-.339c1.075,2.359-.145,4.07-2.725,3.822a8.986,8.986,0,0,1-6.62-4.721C.332,1.51,1.553-.2,4.133.047A8.986,8.986,0,0,1,10.753,4.767Zm-.087-.148c1.333,2.47.186,5.109-2.619,5.028A9.727,9.727,0,0,1,.555,5.03C-.778,2.56.368-.079,3.173,0A9.727,9.727,0,0,1,10.666,4.62Z",
    transform: "matrix(0.799, -0.602, 0.602, 0.799, 41.169, 207.052)",
    fill: "none",
    stroke: "#fbb516",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mission_Target_illustration",
    "data-name": "Mission Target illustration",
    transform: "translate(-141.23 1682.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circles",
    transform: "translate(16.422 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11400",
    "data-name": "Path 11400",
    d: "M288.692,153.261a91.33,91.33,0,0,0-9.456-24.143,110.9,110.9,0,0,0-36.157-38.676,88.971,88.971,0,0,0-22.516-10.657,61.94,61.94,0,0,0-23.407-2.79,41.806,41.806,0,0,0-20.268,6.859,37.132,37.132,0,0,0-13.137,16.121,51.625,51.625,0,0,0-3.759,23.95,80.987,80.987,0,0,0,8.061,29.336,109.407,109.407,0,0,0,19.377,28.1,106.515,106.515,0,0,0,25.887,20.113,80.616,80.616,0,0,0,27.515,9.495,49.985,49.985,0,0,0,24.725-2.4A36.678,36.678,0,0,0,282.53,195.58a43.149,43.149,0,0,0,7.441-19.416A64.453,64.453,0,0,0,288.692,153.261Z",
    transform: "translate(-152.047 -76.801)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11401",
    "data-name": "Path 11401",
    d: "M311.356,198.27a25.064,25.064,0,0,1-5.193,11.51,22.163,22.163,0,0,1-10.812,7.131,31.675,31.675,0,0,1-14.959.7,50.606,50.606,0,0,1-16.16-6.046,66.468,66.468,0,0,1-15-11.859,65.746,65.746,0,0,1-11.394-16.276,50.142,50.142,0,0,1-5.154-17.207,32.519,32.519,0,0,1,1.589-14.494,22.5,22.5,0,0,1,7.324-10.27,24.258,24.258,0,0,1,12.052-4.883,35.652,35.652,0,0,1,14.455,1.24,54.716,54.716,0,0,1,14.3,6.472A66.243,66.243,0,0,1,295.273,154.9a67.387,67.387,0,0,1,10.153,13.951,53.362,53.362,0,0,1,5.658,15.269A37.21,37.21,0,0,1,311.356,198.27Z",
    transform: "translate(-196.529 -113.245)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11405",
    "data-name": "Path 11405",
    d: "M298.27,165.573a75.695,75.695,0,0,0-7.789-20.423,91.831,91.831,0,0,0-13.6-18.6,90.585,90.585,0,0,0-17.09-14.184,75.26,75.26,0,0,0-19.105-8.875,51.116,51.116,0,0,0-19.609-2.054,33.749,33.749,0,0,0-16.7,6.123,31.181,31.181,0,0,0-10.541,13.68,43.341,43.341,0,0,0-2.713,19.881,68.312,68.312,0,0,0,6.859,23.988,91.185,91.185,0,0,0,15.889,22.865,90,90,0,0,0,21.082,16.509,67.647,67.647,0,0,0,22.555,8.061,42.212,42.212,0,0,0,20.539-1.55,30.572,30.572,0,0,0,14.416-10.347,35.583,35.583,0,0,0,6.588-16.005A51.7,51.7,0,0,0,298.27,165.573Zm-12.362,11.2a25.064,25.064,0,0,1-5.193,11.51,22.162,22.162,0,0,1-10.812,7.131,31.675,31.675,0,0,1-14.959.7,50.6,50.6,0,0,1-16.16-6.046,66.468,66.468,0,0,1-15-11.859,65.746,65.746,0,0,1-11.394-16.277,50.142,50.142,0,0,1-5.154-17.207,32.52,32.52,0,0,1,1.589-14.494,22.5,22.5,0,0,1,7.324-10.27,24.259,24.259,0,0,1,12.052-4.883,35.652,35.652,0,0,1,14.455,1.24,54.715,54.715,0,0,1,14.3,6.472,66.242,66.242,0,0,1,12.866,10.618,67.388,67.388,0,0,1,10.153,13.951,53.362,53.362,0,0,1,5.658,15.269A37.21,37.21,0,0,1,285.908,176.773Zm-16.9-26.973a41.717,41.717,0,0,0-6.588-9.107,42.161,42.161,0,0,0-8.371-6.859,34.124,34.124,0,0,0-9.262-4.069,22.934,22.934,0,0,0-9.262-.581,15.038,15.038,0,0,0-7.518,3.333,14.379,14.379,0,0,0-4.379,6.666,21.5,21.5,0,0,0-.775,9.185,33.061,33.061,0,0,0,3.372,10.7,42.726,42.726,0,0,0,7.092,10.037,41.407,41.407,0,0,0,9.262,7.363,33.275,33.275,0,0,0,10.037,3.914,20.419,20.419,0,0,0,9.456-.194,14.52,14.52,0,0,0,7.014-4.263,15.615,15.615,0,0,0,3.527-7.169,22.626,22.626,0,0,0,0-8.991A36.907,36.907,0,0,0,269.011,149.8Zm-10.153,10.657a6.183,6.183,0,0,1-4.689,4.728,9.416,9.416,0,0,1-4.03,0,14.23,14.23,0,0,1-4.185-1.705,17.969,17.969,0,0,1-3.837-3.1,18.318,18.318,0,0,1-2.945-4.147,13.994,13.994,0,0,1-1.473-4.457,9.276,9.276,0,0,1,.233-3.914,6.248,6.248,0,0,1,1.783-2.907,6.492,6.492,0,0,1,3.139-1.55,9.988,9.988,0,0,1,3.992.155,15.174,15.174,0,0,1,4.03,1.705,19.122,19.122,0,0,1,3.682,2.984,17.435,17.435,0,0,1,2.868,3.992,14.7,14.7,0,0,1,1.511,4.3A8.8,8.8,0,0,1,258.858,160.458Z",
    transform: "translate(-171.081 -91.748)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11407",
    "data-name": "Path 11407",
    d: "M258.983,228.333c-.581.349-1.2.7-1.821,1.008s-1.279.62-1.938.93-1.318.581-2.015.853c-.465.194-.93.349-1.4.5-.039,0-.039,0-.078.039-.194.078-.388.116-.581.194a10.694,10.694,0,0,1-1.046.31c-.194.039-.388.116-.581.155-.349.078-.659.194-1.008.271-.194.039-.388.116-.62.155-.349.077-.659.155-1.008.233-.194.039-.388.078-.62.116a9.912,9.912,0,0,1-1.046.194l-.581.116c-.233.039-.465.077-.736.116-.233.039-.5.078-.736.116a4.748,4.748,0,0,1-.736.077c-.233.039-.5.039-.736.078s-.5.039-.736.078-.5.039-.736.078c-.271,0-.5.039-.775.039s-.581.039-.853.039a2.559,2.559,0,0,0-.543.039c-.465,0-.93.039-1.4.039h-2.054c-.31,0-.659-.039-.969-.039a2.21,2.21,0,0,1-.5-.039c-.388-.039-.736-.039-1.124-.078a1.073,1.073,0,0,1-.349-.039c-.5-.039-.969-.077-1.473-.155-.116,0-.233-.039-.388-.039-.388-.039-.775-.078-1.163-.155a1.647,1.647,0,0,1-.426-.078c-.426-.077-.891-.116-1.318-.194-.078,0-.116-.039-.194-.039-.5-.078-1.008-.155-1.511-.271-.155-.039-.31-.039-.426-.077l-1.163-.233a1.648,1.648,0,0,0-.426-.078c-.5-.116-.969-.233-1.473-.349-.116-.039-.271-.078-.388-.116-.388-.078-.736-.194-1.124-.271a2.856,2.856,0,0,1-.543-.155c-.426-.116-.814-.233-1.24-.349-.078-.039-.194-.039-.271-.078-.039,0-.116-.039-.155-.039-.426-.116-.891-.271-1.318-.388-.194-.077-.388-.116-.581-.194-.349-.116-.7-.233-1.008-.349-.155-.078-.349-.116-.5-.194-.465-.155-.969-.349-1.434-.5-.194-.077-.349-.116-.543-.194-.349-.116-.7-.271-1.008-.388l-.581-.233-1.163-.465a4.025,4.025,0,0,0-.388-.155c-.5-.194-1.008-.426-1.473-.659-.194-.078-.349-.155-.543-.233-.349-.155-.7-.31-1.046-.5a3.543,3.543,0,0,1-.543-.271,12.327,12.327,0,0,1-1.24-.62,1.16,1.16,0,0,1-.31-.155c-.5-.271-1.046-.543-1.55-.814a4.229,4.229,0,0,1-.426-.233,10.441,10.441,0,0,1-1.124-.62c-.194-.116-.349-.194-.543-.31-.349-.194-.736-.426-1.085-.62-.155-.116-.349-.194-.5-.31-.349-.194-.736-.426-1.085-.659a3.873,3.873,0,0,0-.543-.31l-1.511-.93-.039-.039c-.116-.077-.271-.155-.388-.233-.388-.271-.814-.5-1.2-.775l-.7-.465c-.271-.194-.581-.388-.853-.581-.349-.233-.659-.465-1.008-.7-.233-.155-.426-.31-.659-.465-.349-.233-.7-.5-1.046-.736-.194-.155-.426-.31-.62-.465l-1.046-.814-.581-.465-1.046-.814c-.194-.155-.349-.271-.543-.426-.659-.543-1.356-1.085-2.015-1.666-.077-.039-.116-.116-.194-.155l-1.744-1.511a4.911,4.911,0,0,0-.5-.426c-.5-.465-1.046-.93-1.55-1.4-.116-.116-.271-.233-.388-.349-.62-.581-1.24-1.163-1.86-1.783l-.581-.581c-.31-.31-.659-.62-.969-.969l-.659-.659c-.31-.31-.581-.62-.891-.93-.233-.233-.426-.465-.659-.7-.271-.31-.581-.62-.853-.93-.233-.233-.426-.465-.659-.7-.271-.31-.581-.62-.853-.969-.194-.233-.426-.465-.62-.7-.271-.349-.581-.659-.853-1.008l-.581-.7c-.271-.349-.581-.7-.853-1.046-.194-.233-.349-.426-.543-.659-.31-.388-.581-.736-.891-1.124-.155-.194-.31-.426-.465-.62-.31-.388-.62-.814-.891-1.2-.155-.194-.271-.388-.426-.581-.31-.426-.62-.891-.93-1.318-.116-.155-.233-.349-.349-.5-.349-.5-.659-.969-1.008-1.473-.077-.116-.155-.233-.271-.388-.388-.581-.775-1.2-1.163-1.821,0-.039-.039-.039-.039-.077-.426-.659-.814-1.279-1.2-1.938s-.775-1.279-1.163-1.938a1.212,1.212,0,0,1-.194-.388c-.31-.5-.581-1.046-.891-1.55-.116-.233-.233-.426-.349-.659l-.7-1.279c-.155-.271-.271-.543-.426-.814l-.581-1.163c-.271-.543-.543-1.085-.814-1.666-.349-.736-.7-1.511-1.046-2.248a5.964,5.964,0,0,1-.31-.736c-.233-.5-.426-1.008-.62-1.511-.116-.31-.233-.581-.349-.891-.194-.465-.349-.891-.543-1.356l-.349-.93c-.155-.465-.349-.93-.5-1.356-.077-.233-.155-.465-.271-.736-.194-.543-.349-1.085-.543-1.589-.039-.155-.116-.349-.155-.5-.233-.7-.426-1.4-.62-2.093a2.506,2.506,0,0,0-.155-.5c-.155-.543-.31-1.085-.426-1.628-.039-.155-.078-.349-.116-.5l-.465-1.976v-.039c-.155-.659-.271-1.318-.426-1.976-.039-.155-.078-.349-.116-.5-.116-.659-.233-1.279-.349-1.9v-.039c-.116-.62-.194-1.279-.271-1.9,0-.155-.039-.271-.039-.426-.077-.62-.155-1.24-.194-1.86a.853.853,0,0,0-.039-.31c-.039-.62-.116-1.2-.155-1.783v-.155c-.039-.62-.078-1.24-.078-1.86v-.349c0-.581-.039-1.2-.039-1.783v-.31c0-.62,0-1.2.039-1.783v-.155c.039-.581.039-1.124.078-1.705V138c.039-.581.077-1.124.155-1.705,0-.116.039-.194.039-.31.078-.543.116-1.085.194-1.628,0-.116.039-.194.039-.271.077-.543.155-1.124.271-1.666v-.078c.116-.543.194-1.085.31-1.589,0-.077.039-.155.039-.233.116-.5.233-1.046.388-1.55.039-.116.039-.194.078-.31.155-.5.271-1.008.426-1.511,0-.078.039-.116.039-.194l.465-1.4c.039-.077.039-.155.078-.233.155-.465.349-.93.543-1.4.039-.116.078-.194.116-.31.194-.465.349-.891.543-1.356,0-.039.039-.039.039-.078.194-.465.426-.93.62-1.356.039-.116.116-.233.155-.349l.581-1.163c.039-.077.077-.116.116-.194a13.066,13.066,0,0,1,.736-1.24c.077-.116.155-.271.233-.388.194-.31.388-.62.581-.891.077-.116.194-.271.271-.388.233-.349.465-.659.7-1.008.039-.078.116-.155.155-.233.31-.426.62-.853.969-1.279l-1.124,1.4-.039.039a.535.535,0,0,0-.116.155l-.116.155c-.077.078-.155.194-.233.271l-.426.543a1.639,1.639,0,0,0-.194.271l-.581.736a1.685,1.685,0,0,1-.233.271,5.7,5.7,0,0,0-.388.5l-.349.426h0c-.194.233-.426.543-.659.814l-.31.388a.811.811,0,0,0-.155.233c-.039.039-.077.116-.155.194l-.116.155c-.155.194-.349.426-.5.62a5.694,5.694,0,0,0-.388.5l-.271.349c0,.039-.039.039-.039.078a1.72,1.72,0,0,0-.31.426l-.31.388c-.077.116-.194.233-.271.349l-.194.271-.039.039-.039.039-.039.039-.039.039c-.271.349-.5.659-.775,1.008l-.039.039c-.039.077-.116.155-.155.233-.194.233-.349.5-.543.736-.039.077-.116.155-.155.233-.078.116-.194.271-.271.388-.077.155-.194.271-.271.426a5.738,5.738,0,0,0-.31.5c-.077.116-.155.271-.233.388-.039.077-.077.116-.116.194-.194.31-.388.659-.581.969,0,.039-.039.039-.039.078-.039.077-.077.116-.116.194a6.732,6.732,0,0,0-.388.736c-.078.116-.116.271-.194.388s-.116.233-.194.349a.972.972,0,0,1-.155.271c-.155.349-.349.7-.5,1.046v.039c0,.039-.039.039-.039.077-.116.31-.271.581-.388.891-.077.155-.116.31-.194.465-.039.116-.078.194-.116.31l-.116.233c-.116.349-.271.659-.388,1.008,0,.039-.039.077-.039.155,0,.039-.039.039-.039.078a.233.233,0,0,0-.039.155c-.077.233-.155.426-.233.659s-.155.5-.233.736c0,.077-.039.116-.039.194a.135.135,0,0,1-.039.078c-.116.349-.194.659-.31,1.008-.039.116-.077.271-.116.388s-.039.194-.077.31a1.2,1.2,0,0,0-.078.31c-.077.349-.194.7-.271,1.046,0,.039-.039.116-.039.155,0,.078-.039.155-.039.233a3.628,3.628,0,0,1-.155.62c-.078.31-.116.62-.194.969v.116c-.077.349-.116.7-.194,1.046a2.991,2.991,0,0,0-.078.581c0,.078-.039.194-.039.271s-.039.155-.039.233c-.039.349-.116.7-.155,1.085,0,.116-.039.233-.039.31,0,.116-.039.194-.039.31,0,.155-.039.31-.039.465-.039.349-.077.736-.116,1.085v.31c-.039.271-.039.5-.078.775a6.859,6.859,0,0,0-.039.891v.233c0,.388-.039.775-.039,1.124V154c0,.388.039.814.039,1.2v.194a8.182,8.182,0,0,0,.078,1.008,4.749,4.749,0,0,0,.077.736.853.853,0,0,0,.039.31v.194c.039.426.077.891.116,1.318,0,.116.039.233.039.349,0,.155.039.271.039.426.039.194.039.388.077.581.039.426.116.853.194,1.279v.039h0c.078.465.155.891.233,1.356a2.617,2.617,0,0,1,.077.543,2.268,2.268,0,0,1,.078.5c.039.155.039.271.077.426.077.5.194,1.008.31,1.473h0v.039c.116.465.194.93.31,1.434.039.155.077.349.116.5s.078.349.116.5.078.31.116.5c.077.388.194.736.31,1.124.039.155.077.349.116.5,0,.039.039.078.039.155.155.581.349,1.163.5,1.744,0,.039.039.078.039.155.039.155.116.349.155.5.116.388.233.736.349,1.124.039.155.116.31.155.426l.232.7c.078.194.155.426.233.62a5.177,5.177,0,0,0,.271.7c.116.31.233.62.349.891.039.155.116.271.155.426.116.31.233.62.349.891s.233.581.349.853c.039.078.078.194.116.271.155.388.349.775.5,1.2.116.233.194.5.31.736.039.039.039.077.077.155.31.7.62,1.356.93,2.054.039.116.116.233.155.349s.116.233.155.349.116.233.155.349.116.233.155.349l.116.233.581,1.163c.116.271.271.543.388.775.233.426.426.814.659,1.24.116.233.233.426.349.659.271.5.543,1.008.853,1.511.078.116.116.233.194.349.736,1.279,1.511,2.558,2.286,3.8,0,.039.039.039.039.078.388.581.736,1.163,1.124,1.744l.233.349c.31.465.659.969.969,1.434a5.669,5.669,0,0,1,.349.5c.31.426.62.853.891,1.279.039.039.077.116.116.155a2.714,2.714,0,0,0,.31.388c.271.388.581.775.891,1.163.155.194.31.388.465.62.271.349.581.736.853,1.085.155.233.349.426.5.659.271.349.543.7.853,1.046.194.233.388.465.543.659.271.31.543.659.814.969a2.715,2.715,0,0,1,.31.388c.078.116.194.194.271.31l.814.93c.194.233.426.465.62.7.271.31.543.581.814.891.194.233.426.465.659.7l.233.233c.194.233.426.426.62.659s.426.426.62.659l.93.93.465.465.078.078c.581.581,1.2,1.163,1.821,1.744l.116.116c.077.078.194.155.271.233.5.465,1.008.93,1.511,1.356a1.685,1.685,0,0,0,.271.233c.078.078.155.116.233.194.581.5,1.124.969,1.705,1.473a.535.535,0,0,0,.155.116l.039.039c.659.543,1.318,1.085,1.976,1.589.039.039.078.077.116.077.155.116.271.233.426.349.349.271.7.543,1.008.814a.535.535,0,0,0,.155.116c.155.116.31.233.426.31.349.271.7.5,1.008.775.039.039.116.078.155.116a3.232,3.232,0,0,0,.465.31c.349.233.659.5,1.008.736.039.039.116.077.155.116a3.235,3.235,0,0,0,.465.31c.31.233.659.465.969.659.078.039.116.078.194.116a136188.023,136188.023,0,0,1,1.318.853c.039.039.078.039.116.077.349.233.7.465,1.085.7a4.085,4.085,0,0,1,.426.271c.465.271.93.581,1.4.853a.135.135,0,0,1,.078.039c.194.116.349.194.543.31a9.276,9.276,0,0,1,.814.5l.232.116c.155.078.349.194.5.271l.581.349a2.89,2.89,0,0,1,.465.271c.116.039.194.116.31.155l.233.116c.116.077.233.116.349.194a7.227,7.227,0,0,0,.775.388c.155.078.271.155.426.233.039.039.078.039.116.078.465.233.891.465,1.356.659a.038.038,0,0,1,.039.039.971.971,0,0,1,.271.155l.93.465c.116.039.194.078.31.116.194.078.349.155.543.233a2.371,2.371,0,0,0,.465.194,3.911,3.911,0,0,1,.581.271c.155.078.349.155.5.233.039.039.116.039.155.078.426.194.853.349,1.279.543h0a1.378,1.378,0,0,1,.349.155c.271.116.581.233.853.349.078.039.194.078.271.116l.581.233a4.02,4.02,0,0,0,.388.155c.194.078.426.155.62.233.155.078.349.116.5.194.039,0,.039.039.078.039.426.155.814.271,1.24.426.039,0,.078.039.116.039.155.039.349.116.5.155.194.078.388.116.581.194.155.039.271.078.426.116a3.976,3.976,0,0,0,.543.155c.077.039.155.039.233.078.349.116.7.194,1.085.31.116.039.271.078.388.116a8.419,8.419,0,0,1,.93.271c.078.039.194.039.271.078.155.039.349.078.5.116.116.039.271.078.388.116a4.118,4.118,0,0,0,.736.155,1.377,1.377,0,0,0,.388.078c.039,0,.039,0,.078.039.388.078.814.194,1.2.271.078,0,.116.039.194.039.155.039.271.039.426.078l.581.116c.194.039.349.078.543.116.155.039.271.039.426.078.078,0,.155.039.233.039.388.078.814.116,1.2.194h.039a.349.349,0,0,1,.194.039c.31.039.62.078.969.155.116,0,.233.039.349.039a1.679,1.679,0,0,1,.194.039.492.492,0,0,1,.233.039c.116,0,.271.039.388.039.233.039.5.039.736.077.116,0,.233.039.388.039h.116c.426.039.814.078,1.24.116h.078a1.073,1.073,0,0,1,.349.039c.271,0,.543.039.775.039h.31a2.21,2.21,0,0,1,.5.039h2.945c.426,0,.853,0,1.279-.039h.116a2.558,2.558,0,0,0,.543-.039,3.333,3.333,0,0,0,.62-.039h.233a4.748,4.748,0,0,0,.736-.078c.155,0,.271-.039.426-.039.116,0,.194-.039.31-.039.233-.039.5-.039.736-.078.116,0,.233-.039.349-.039s.233-.039.349-.039c.233-.039.5-.078.736-.116.116,0,.194-.039.31-.039.155-.039.271-.039.426-.078l.7-.116c.078,0,.155-.039.233-.039.116-.039.233-.039.349-.078.349-.078.7-.116,1.046-.194a.659.659,0,0,1,.271-.039c.116-.039.194-.039.31-.078.349-.077.659-.155,1.008-.233.116-.039.233-.039.349-.078.078-.039.155-.039.233-.078.349-.078.659-.194.969-.271.155-.039.271-.077.426-.116.039,0,.116-.039.155-.039l1.046-.349c.155-.039.271-.077.426-.116.039-.039.116-.039.155-.078.039,0,.039,0,.078-.039s.116-.039.155-.078a1.62,1.62,0,0,0,.388-.155c.116-.039.271-.116.388-.155s.271-.116.388-.155c.7-.271,1.356-.543,2.015-.853s1.279-.62,1.938-.93c.62-.31,1.24-.659,1.821-1.008s1.163-.7,1.744-1.085l10.115-6.7C260.146,227.635,259.565,227.984,258.983,228.333Z",
    transform: "translate(-139.7 -99.4)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11408",
    "data-name": "Path 11408",
    d: "M185.484,204.306a106.515,106.515,0,0,0,25.887,20.113,80.617,80.617,0,0,0,27.515,9.495,49.986,49.986,0,0,0,24.725-2.4,34.586,34.586,0,0,0,5.774-2.79c-.388.194-.736.426-1.124.62-.62.31-1.279.62-1.938.93s-1.318.581-2.015.853c-.465.194-.93.349-1.4.5-.039,0-.039,0-.078.039-.194.078-.388.116-.581.194a10.687,10.687,0,0,1-1.046.31c-.194.039-.388.116-.581.155-.349.078-.659.194-1.008.271-.194.039-.388.116-.62.155-.349.078-.659.155-1.008.233-.194.039-.388.078-.62.116a9.915,9.915,0,0,1-1.046.194l-.581.116c-.233.039-.465.078-.736.116-.233.039-.5.078-.736.116a4.748,4.748,0,0,1-.736.078c-.233.039-.5.039-.736.077s-.5.039-.736.078-.5.039-.736.078c-.271,0-.5.039-.775.039s-.581.039-.853.039a2.558,2.558,0,0,0-.543.039c-.465,0-.93.039-1.4.039h-2.054c-.31,0-.659-.039-.969-.039a2.209,2.209,0,0,1-.5-.039c-.388-.039-.736-.039-1.124-.078a1.073,1.073,0,0,1-.349-.039c-.5-.039-.969-.078-1.473-.155-.116,0-.233-.039-.388-.039-.388-.039-.775-.077-1.163-.155a1.648,1.648,0,0,1-.426-.078c-.426-.078-.891-.116-1.318-.194-.078,0-.116-.039-.194-.039-.5-.077-1.008-.155-1.511-.271-.155-.039-.31-.039-.426-.078l-1.163-.233a1.648,1.648,0,0,0-.426-.078c-.5-.116-.969-.233-1.473-.349-.116-.039-.271-.078-.388-.116-.388-.078-.736-.194-1.124-.271a2.854,2.854,0,0,1-.543-.155c-.426-.116-.814-.233-1.24-.349-.078-.039-.194-.039-.271-.078-.039,0-.116-.039-.155-.039-.426-.116-.891-.271-1.318-.388-.194-.078-.388-.116-.581-.194-.349-.116-.7-.233-1.008-.349-.155-.078-.349-.116-.5-.194-.465-.155-.969-.349-1.434-.5-.194-.078-.349-.116-.543-.194-.349-.116-.7-.271-1.008-.388l-.581-.233-1.163-.465a4.03,4.03,0,0,0-.388-.155c-.5-.194-1.008-.426-1.473-.659-.194-.078-.349-.155-.543-.233-.349-.155-.7-.31-1.046-.5a3.543,3.543,0,0,1-.543-.271,12.337,12.337,0,0,1-1.24-.62,1.161,1.161,0,0,1-.31-.155c-.5-.271-1.046-.543-1.55-.814a4.227,4.227,0,0,1-.426-.233,10.437,10.437,0,0,1-1.124-.62c-.194-.116-.349-.194-.543-.31-.349-.194-.736-.426-1.085-.62-.155-.116-.349-.194-.5-.31-.349-.194-.736-.426-1.085-.659a3.871,3.871,0,0,0-.543-.31l-1.511-.93-.039-.039c-.116-.078-.271-.155-.388-.233-.388-.271-.814-.5-1.2-.775l-.7-.465c-.271-.194-.581-.388-.853-.581-.349-.233-.659-.465-1.008-.7-.233-.155-.426-.31-.659-.465-.349-.233-.7-.5-1.046-.736-.194-.155-.426-.31-.62-.465l-1.046-.814-.581-.465-1.046-.814c-.194-.155-.349-.271-.543-.426-.659-.543-1.356-1.085-2.015-1.666-.077-.039-.116-.116-.194-.155l-1.744-1.511a4.908,4.908,0,0,0-.5-.426c-.5-.465-1.046-.93-1.55-1.4-.116-.116-.271-.233-.388-.349-.62-.581-1.24-1.163-1.86-1.783l-.581-.581c-.31-.31-.659-.62-.969-.969l-.659-.659c-.31-.31-.581-.62-.891-.93-.233-.233-.426-.465-.659-.7-.271-.31-.581-.62-.853-.93-.233-.233-.426-.465-.659-.7-.271-.31-.581-.62-.853-.969-.194-.233-.426-.465-.62-.7-.271-.349-.581-.659-.853-1.008l-.581-.7c-.271-.349-.581-.7-.853-1.046-.194-.233-.349-.426-.543-.659-.31-.388-.581-.736-.891-1.124-.155-.194-.31-.426-.465-.62-.31-.388-.62-.814-.891-1.2-.155-.194-.271-.388-.426-.581-.31-.426-.62-.891-.93-1.318-.116-.155-.233-.349-.349-.5-.349-.5-.659-.969-1.008-1.473-.077-.116-.155-.233-.271-.388-.388-.581-.775-1.2-1.163-1.821,0-.039-.039-.039-.039-.078-.426-.659-.814-1.279-1.2-1.938s-.775-1.279-1.163-1.938a1.212,1.212,0,0,1-.194-.388c-.31-.5-.581-1.046-.891-1.55-.116-.233-.233-.426-.349-.659l-.7-1.279c-.155-.271-.271-.543-.426-.814l-.581-1.163c-.271-.543-.543-1.085-.814-1.666-.349-.736-.7-1.511-1.046-2.248a5.965,5.965,0,0,1-.31-.736c-.233-.5-.426-1.008-.62-1.511-.116-.31-.233-.581-.349-.891-.194-.465-.349-.891-.543-1.356l-.349-.93c-.155-.465-.349-.93-.5-1.356-.078-.233-.155-.465-.271-.736-.194-.543-.349-1.085-.543-1.589-.039-.155-.116-.349-.155-.5-.233-.7-.426-1.4-.62-2.093a2.508,2.508,0,0,0-.155-.5c-.155-.543-.31-1.085-.426-1.628-.039-.155-.078-.349-.116-.5l-.465-1.976v-.039c-.155-.659-.271-1.318-.426-1.976-.039-.155-.078-.349-.116-.5-.116-.659-.233-1.279-.349-1.9v-.039c-.116-.62-.194-1.279-.271-1.9,0-.155-.039-.271-.039-.426-.077-.62-.155-1.24-.194-1.86a.853.853,0,0,0-.039-.31c-.039-.62-.116-1.2-.155-1.783v-.155c-.039-.62-.078-1.24-.078-1.86v-.349c0-.581-.039-1.2-.039-1.783v-.31c0-.62,0-1.2.039-1.783v-.155c.039-.581.039-1.124.078-1.705V138c.039-.581.077-1.124.155-1.705,0-.116.039-.194.039-.31.078-.543.116-1.085.194-1.628,0-.116.039-.194.039-.271.077-.543.155-1.124.271-1.666v-.077c.116-.543.194-1.085.31-1.589,0-.077.039-.155.039-.233.116-.5.233-1.046.388-1.55.039-.116.039-.194.077-.31.155-.5.271-1.008.426-1.511,0-.077.039-.116.039-.194l.465-1.4c.039-.077.039-.155.078-.233.155-.465.349-.93.543-1.4.039-.116.078-.194.116-.31.194-.465.349-.891.543-1.356,0-.039.039-.039.039-.078.194-.465.426-.93.62-1.356.039-.116.116-.233.155-.349l.581-1.163c.039-.078.077-.116.116-.194a13.069,13.069,0,0,1,.736-1.24c.078-.116.155-.271.233-.388.194-.31.388-.62.581-.891.077-.116.194-.271.271-.388.233-.349.465-.659.7-1.008.039-.078.116-.155.155-.233.31-.426.62-.853.969-1.279l-1.124,1.4-.039.039a.535.535,0,0,0-.116.155l-.116.155c-.077.078-.155.194-.233.271l-.426.543a1.64,1.64,0,0,0-.194.271l-.581.736a1.685,1.685,0,0,1-.233.271,4.12,4.12,0,0,0-.349.426,40.114,40.114,0,0,0-2.48,4.805,51.625,51.625,0,0,0-3.759,23.95,80.986,80.986,0,0,0,8.061,29.336A110.33,110.33,0,0,0,185.484,204.306Z",
    transform: "translate(-150.761 -99.4)",
    fill: "url(#linear-gradient-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "attow_stick_2",
    "data-name": "attow stick 2",
    transform: "translate(93.909 19.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11410",
    "data-name": "Path 11410",
    d: "M364.687,219.691c-1.55,1.2-4.379-.543-6.317-3.875-1.976-3.333-2.286-7.014-.775-8.216,1.55-1.2,4.379.543,6.317,3.875C365.889,214.808,366.2,218.489,364.687,219.691Z",
    transform: "translate(-350.058 -176.191)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11409",
    "data-name": "Path 11409",
    d: "M353.194,221.291c-1.589.039-3.682-1.589-5.27-4.263-1.783-3.023-2.209-6.356-1.124-7.828l-6.743,9.185c-.039.039-.039.078-.078.116.039-.039.039-.078.078-.116a2.054,2.054,0,0,0,1.744,3.294h0Z",
    transform: "translate(-339.65 -177.403)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11412",
    "data-name": "Path 11412",
    d: "M363.177,222.763,360.7,218.5l-2.6,1.821a13.61,13.61,0,0,0,2.4,4.263Z",
    transform: "translate(-350.95 -183.099)",
    opacity: 0.3,
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11413",
    "data-name": "Path 11413",
    d: "M431.172,127.3l-5.232,2.79c-.775.426-1.55.814-2.325,1.24l-4.65,2.48c-.93.5-1.86.969-2.79,1.473L414.2,136.33c-4.96,2.635-10.076,5.348-15.23,8.061l-2.248,1.2c-8.875,4.689-17.71,9.378-25.771,13.641l-.93.5c-1.783.93-3.565,1.86-5.232,2.79a.083.083,0,0,0-.078.077c-.078.039-.116.116-.194.233a.135.135,0,0,1-.039.077c-.039.077-.039.116-.077.194v.7a1.132,1.132,0,0,0,.077.349h0c0,.039.039.077.039.116.039.116.039.194.078.31h0v.039a1.376,1.376,0,0,0,.155.349c.039.039.039.078.078.116.039.078.039.116.078.194.039.039.078.116.116.155.039.077.116.194.155.271,0,.039.039.039.039.077a.535.535,0,0,1,.116.155c.039.077.116.116.155.194l.116.116.078.078.077.077c.039.039.116.077.155.155.039,0,.039.039.078.078s.039.039.078.039c.039.039.078.039.116.077.039,0,.039.039.078.039a.135.135,0,0,1,.078.039.142.142,0,0,0,.116.039.038.038,0,0,1,.039.039h.078c.039,0,.116.039.155.039h.233a.3.3,0,0,0,.194-.078l66.462-35.188Z",
    transform: "translate(-354.808 -127.243)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11414",
    "data-name": "Path 11414",
    d: "M538.109,128.643c-.7-1.163-1.705-1.783-2.248-1.356s-.426,1.705.271,2.907c.7,1.163,1.705,1.783,2.248,1.356S538.807,129.806,538.109,128.643Z",
    transform: "translate(-459.614 -127.152)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11415",
    "data-name": "Path 11415",
    d: "M538.109,128.643c-.7-1.163-1.705-1.783-2.248-1.356s-.426,1.705.271,2.907c.7,1.163,1.705,1.783,2.248,1.356S538.807,129.806,538.109,128.643Zm.194,2.79a.474.474,0,0,1-.349.116h0c-.543,0-1.2-.581-1.705-1.434-.659-1.124-.775-2.364-.31-2.752a.474.474,0,0,1,.349-.116c.543,0,1.2.581,1.705,1.434C538.652,129.806,538.807,131.085,538.3,131.434Z",
    transform: "translate(-459.614 -127.152)",
    opacity: 0.5,
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heart_Tail_2",
    "data-name": "Heart Tail 2",
    transform: "translate(149.308 13.418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11416",
    "data-name": "Path 11416",
    d: "M507.217,145.627c.581,2.48-.349,5.7-5.542,7.673-6.821,2.6-14.649-1.744-15.075-1.976l17.865-9.223C505.434,142.216,506.791,143.689,507.217,145.627Z",
    transform: "translate(-485.05 -130.212)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11418",
    "data-name": "Path 11418",
    d: "M498.683,114.785c1.279,2.015,1.666,4.5,1.2,5.5L482.6,129.434c.039-.581,1.046-11.549,6.9-15.773C493.955,110.444,497.016,112.227,498.683,114.785Z",
    transform: "translate(-482.6 -111.732)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11419",
    "data-name": "Path 11419",
    d: "M507.06,119.243v.077a.492.492,0,0,1-.039.233v.039c0,.077-.039.116-.039.194h0c-.039.078-.039.155-.078.194l.233-.31a8.386,8.386,0,0,0-1.318-5.387c-1.628-2.6-4.767-4.34-9.262-1.085a9.917,9.917,0,0,0-1.628,1.511l-.465.581-.465.659a11.467,11.467,0,0,1,2.519-2.6l.7-.465c.039,0,.039-.039.078-.039.233-.116.426-.233.62-.349.039,0,.078-.039.116-.039a3.912,3.912,0,0,1,.581-.271c.039,0,.078-.039.116-.039a3.411,3.411,0,0,1,.581-.194h.078a4.823,4.823,0,0,1,.62-.155h.078a1.073,1.073,0,0,1,.349-.039H501.6a.233.233,0,0,1,.155.039.142.142,0,0,1,.116.039c.039,0,.116.039.155.039a.142.142,0,0,1,.116.039c.039,0,.116.039.155.039s.078.039.116.039.116.039.155.039.078.039.116.039.077.039.116.039.078.039.116.077c.039,0,.078.039.116.039.039.039.116.039.155.077.039,0,.078.039.116.039a1.682,1.682,0,0,0,.271.155.038.038,0,0,1,.039.039l.349.233.039.039a5.959,5.959,0,0,1,.5.465l.039.039c.194.194.349.388.543.62h0c.155.233.31.426.465.659a7.684,7.684,0,0,1,.426.775v.039l.233.465c.039.039.039.078.078.155.039.155.116.271.155.426a.135.135,0,0,0,.039.078c.078.271.155.543.233.775v.039l.116.581v.116c.039.155.039.31.078.465v.659C507.06,119.088,507.06,119.165,507.06,119.243Z",
    transform: "translate(-489.582 -111.423)",
    fill: "url(#linear-gradient-16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stars",
    transform: "translate(0 8.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11431",
    "data-name": "Path 11431",
    d: "M431.361,98.954l.659,1.2a2.428,2.428,0,0,0,.969,1.008l1.163.659a.073.073,0,0,1,0,.116l-1.163.659a2.428,2.428,0,0,0-.969,1.008l-.659,1.2a.073.073,0,0,1-.116,0l-.659-1.2a2.429,2.429,0,0,0-.969-1.008l-1.163-.659a.073.073,0,0,1,0-.116l1.163-.659a2.429,2.429,0,0,0,.969-1.008l.659-1.2C431.283,98.915,431.361,98.915,431.361,98.954Z",
    transform: "translate(-300.112 -98.925)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11432",
    "data-name": "Path 11432",
    d: "M126.238,291.154l.659,1.2a2.521,2.521,0,0,0,1.008,1.008l1.2.659a.073.073,0,0,1,0,.116l-1.2.659A2.521,2.521,0,0,0,126.9,295.8l-.659,1.2a.073.073,0,0,1-.116,0l-.659-1.2a2.521,2.521,0,0,0-1.008-1.008l-1.2-.659a.073.073,0,0,1,0-.116l1.2-.659a2.521,2.521,0,0,0,1.008-1.008l.659-1.2A.073.073,0,0,1,126.238,291.154Z",
    transform: "translate(-113.188 -216.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11433",
    "data-name": "Path 11433",
    d: "M524.538,245.654l.659,1.2a2.521,2.521,0,0,0,1.008,1.008l1.2.659a.073.073,0,0,1,0,.116l-1.2.659A2.521,2.521,0,0,0,525.2,250.3l-.659,1.2a.073.073,0,0,1-.116,0l-.659-1.2a2.521,2.521,0,0,0-1.008-1.008l-1.2-.659a.073.073,0,0,1,0-.116l1.2-.659a2.522,2.522,0,0,0,1.008-1.008l.659-1.2C524.461,245.615,524.538,245.615,524.538,245.654Z",
    transform: "translate(-357.132 -188.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11437",
    "data-name": "Path 11437",
    d: "M99.447,274.1l.465.853a1.521,1.521,0,0,0,.7.7l.853.465c.039,0,.039.077,0,.077l-.853.465a1.521,1.521,0,0,0-.7.7l-.465.853c0,.039-.077.039-.077,0l-.465-.853a1.521,1.521,0,0,0-.7-.7l-.853-.465c-.039,0-.039-.077,0-.077l.853-.465a1.521,1.521,0,0,0,.7-.7l.465-.853Z",
    transform: "translate(-97.325 -206.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11442",
    "data-name": "Path 11442",
    d: "M113.943,178.771a.271.271,0,1,1-.271-.271A.265.265,0,0,1,113.943,178.771Z",
    transform: "translate(-107.17 -147.662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11456",
    "data-name": "Path 11456",
    d: "M586.138,276.354l.659,1.2a2.521,2.521,0,0,0,1.008,1.008l1.2.659a.073.073,0,0,1,0,.116l-1.2.659A2.521,2.521,0,0,0,586.8,281l-.659,1.2a.073.073,0,0,1-.116,0l-.659-1.2A2.521,2.521,0,0,0,584.356,280l-1.2-.659a.073.073,0,0,1,0-.116l1.2-.659a2.522,2.522,0,0,0,1.008-1.008l.659-1.2C586.022,276.315,586.1,276.315,586.138,276.354Z",
    transform: "translate(-394.86 -207.576)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "attow_stick_2-2",
    "data-name": "attow stick 2",
    transform: "translate(123.533 41.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11410-2",
    "data-name": "Path 11410",
    d: "M364.687,219.691c-1.55,1.2-4.379-.543-6.317-3.875-1.976-3.333-2.286-7.014-.775-8.216,1.55-1.2,4.379.543,6.317,3.875C365.889,214.808,366.2,218.489,364.687,219.691Z",
    transform: "translate(-350.058 -176.191)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11409-2",
    "data-name": "Path 11409",
    d: "M353.194,221.291c-1.589.039-3.682-1.589-5.27-4.263-1.783-3.023-2.209-6.356-1.124-7.828l-6.743,9.185c-.039.039-.039.078-.078.116.039-.039.039-.078.078-.116a2.054,2.054,0,0,0,1.744,3.294h0Z",
    transform: "translate(-339.65 -177.403)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11412-2",
    "data-name": "Path 11412",
    d: "M363.177,222.763,360.7,218.5l-2.6,1.821a13.61,13.61,0,0,0,2.4,4.263Z",
    transform: "translate(-350.95 -183.099)",
    opacity: 0.3,
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11413-2",
    "data-name": "Path 11413",
    d: "M431.172,127.3l-5.232,2.79c-.775.426-1.55.814-2.325,1.24l-4.65,2.48c-.93.5-1.86.969-2.79,1.473L414.2,136.33c-4.96,2.635-10.076,5.348-15.23,8.061l-2.248,1.2c-8.875,4.689-17.71,9.378-25.771,13.641l-.93.5c-1.783.93-3.565,1.86-5.232,2.79a.083.083,0,0,0-.078.077c-.078.039-.116.116-.194.233a.135.135,0,0,1-.039.077c-.039.077-.039.116-.077.194v.7a1.132,1.132,0,0,0,.077.349h0c0,.039.039.077.039.116.039.116.039.194.078.31h0v.039a1.376,1.376,0,0,0,.155.349c.039.039.039.078.078.116.039.078.039.116.078.194.039.039.078.116.116.155.039.077.116.194.155.271,0,.039.039.039.039.077a.535.535,0,0,1,.116.155c.039.077.116.116.155.194l.116.116.078.078.077.077c.039.039.116.077.155.155.039,0,.039.039.078.078s.039.039.078.039c.039.039.078.039.116.077.039,0,.039.039.078.039a.135.135,0,0,1,.078.039.142.142,0,0,0,.116.039.038.038,0,0,1,.039.039h.078c.039,0,.116.039.155.039h.233a.3.3,0,0,0,.194-.078l66.462-35.188Z",
    transform: "translate(-354.808 -127.243)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11414-2",
    "data-name": "Path 11414",
    d: "M538.109,128.643c-.7-1.163-1.705-1.783-2.248-1.356s-.426,1.705.271,2.907c.7,1.163,1.705,1.783,2.248,1.356S538.807,129.806,538.109,128.643Z",
    transform: "translate(-459.614 -127.152)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11415-2",
    "data-name": "Path 11415",
    d: "M538.109,128.643c-.7-1.163-1.705-1.783-2.248-1.356s-.426,1.705.271,2.907c.7,1.163,1.705,1.783,2.248,1.356S538.807,129.806,538.109,128.643Zm.194,2.79a.474.474,0,0,1-.349.116h0c-.543,0-1.2-.581-1.705-1.434-.659-1.124-.775-2.364-.31-2.752a.474.474,0,0,1,.349-.116c.543,0,1.2.581,1.705,1.434C538.652,129.806,538.807,131.085,538.3,131.434Z",
    transform: "translate(-459.614 -127.152)",
    opacity: 0.5,
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heart_Tail_2-2",
    "data-name": "Heart Tail 2",
    transform: "translate(178.931 35.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11416-2",
    "data-name": "Path 11416",
    d: "M507.217,145.627c.581,2.48-.349,5.7-5.542,7.673-6.821,2.6-14.649-1.744-15.075-1.976l17.865-9.223C505.434,142.216,506.791,143.689,507.217,145.627Z",
    transform: "translate(-485.05 -130.212)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11418-2",
    "data-name": "Path 11418",
    d: "M498.683,114.785c1.279,2.015,1.666,4.5,1.2,5.5L482.6,129.434c.039-.581,1.046-11.549,6.9-15.773C493.955,110.444,497.016,112.227,498.683,114.785Z",
    transform: "translate(-482.6 -111.732)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11419-2",
    "data-name": "Path 11419",
    d: "M507.06,119.243v.077a.492.492,0,0,1-.039.233v.039c0,.077-.039.116-.039.194h0c-.039.078-.039.155-.078.194l.233-.31a8.386,8.386,0,0,0-1.318-5.387c-1.628-2.6-4.767-4.34-9.262-1.085a9.917,9.917,0,0,0-1.628,1.511l-.465.581-.465.659a11.467,11.467,0,0,1,2.519-2.6l.7-.465c.039,0,.039-.039.078-.039.233-.116.426-.233.62-.349.039,0,.078-.039.116-.039a3.912,3.912,0,0,1,.581-.271c.039,0,.078-.039.116-.039a3.411,3.411,0,0,1,.581-.194h.078a4.823,4.823,0,0,1,.62-.155h.078a1.073,1.073,0,0,1,.349-.039H501.6a.233.233,0,0,1,.155.039.142.142,0,0,1,.116.039c.039,0,.116.039.155.039a.142.142,0,0,1,.116.039c.039,0,.116.039.155.039s.078.039.116.039.116.039.155.039.078.039.116.039.077.039.116.039.078.039.116.077c.039,0,.078.039.116.039.039.039.116.039.155.077.039,0,.078.039.116.039a1.682,1.682,0,0,0,.271.155.038.038,0,0,1,.039.039l.349.233.039.039a5.959,5.959,0,0,1,.5.465l.039.039c.194.194.349.388.543.62h0c.155.233.31.426.465.659a7.684,7.684,0,0,1,.426.775v.039l.233.465c.039.039.039.078.078.155.039.155.116.271.155.426a.135.135,0,0,0,.039.078c.078.271.155.543.233.775v.039l.116.581v.116c.039.155.039.31.078.465v.659C507.06,119.088,507.06,119.165,507.06,119.243Z",
    transform: "translate(-489.582 -111.423)",
    fill: "url(#linear-gradient-16)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionTargetillustration);
export default __webpack_public_path__ + "static/media/Mission Target illustration.365d27cdac1de521fa9bfd2fb47a5dd9.svg";
export { ForwardRef as ReactComponent };